import * as service from './service'

export default {
  namespace: 'widgetMallExpireCoupon',
  state: {
    couponListData: [],
    couponStatusData: []
  },
  effects: {
    * getMyShopCouponList ({ payload }, { call, put }) {
      const res = yield call(service.getMyShopCouponList, payload)
      yield put({
        type: 'save',
        payload: {
          couponListData: res.data.data
        }
      })
      return res.data
    },
    * getShopCouponStatus ({ payload }, { call, put }) {
      const res = yield call(service.getShopCouponStatus, payload)
      yield put({
        type: 'save',
        payload: {
          couponStatusData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
